
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { APP_NAME, APP_SUBHEADING } from '../constants';
import { useAuth } from '../contexts/AuthContext';
import { signOut } from '../services/firebase';

export const Header: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <header className="sticky top-0 z-50 bg-black/90 backdrop-blur-md border-b border-white/10">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="w-10 h-10 bg-white rounded-sm flex items-center justify-center text-black font-black text-xl shadow-[0_0_15px_rgba(255,255,255,0.3)] transition-all group-hover:shadow-[0_0_25px_rgba(255,255,255,0.5)]">
            L
          </div>
          <div className="flex flex-col justify-center">
            <span className="text-2xl font-black tracking-tighter text-white uppercase leading-none">{APP_NAME}</span>
            <div className="flex items-center gap-2">
              <span className="text-[0.65rem] font-mono tracking-[0.2em] text-secondary uppercase mt-1">{APP_SUBHEADING}</span>
            </div>
          </div>
        </Link>
        
        <div className="flex items-center gap-4">
          <nav className="hidden md:flex gap-2">
            <Link 
              to="/" 
              className={`px-4 py-2 rounded-sm text-sm font-medium uppercase tracking-wider transition-all ${
                location.pathname === '/' 
                  ? 'text-black bg-white shadow-[0_0_10px_rgba(255,255,255,0.3)]' 
                  : 'text-slate-400 hover:text-white hover:bg-white/10'
              }`}
            >
              Workout
            </Link>
            <Link 
              to="/history" 
              className={`px-4 py-2 rounded-sm text-sm font-medium uppercase tracking-wider transition-all ${
                location.pathname === '/history' 
                  ? 'text-black bg-white shadow-[0_0_10px_rgba(255,255,255,0.3)]' 
                  : 'text-slate-400 hover:text-white hover:bg-white/10'
              }`}
            >
              History
            </Link>
          </nav>

          {user && (
            <div className="flex items-center gap-4">
              <span className="hidden sm:block text-xs font-mono text-slate-300">
                {user.email}
              </span>
              <button 
                onClick={handleSignOut}
                className="text-xs font-bold text-red-500 hover:text-red-400 uppercase tracking-wide border border-red-500/30 px-3 py-1 rounded-sm hover:bg-red-500/10 transition-colors"
              >
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};